import LegacyEntityPage from './legacy-entity-page'

export default LegacyEntityPage
